import React from 'react';
import { createRoot } from 'react-dom/client';
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';
import {Provider} from 'react-redux';
import store from './store';
import './index.css';
import App from './App';
import {BrowserRouter as Router} from 'react-router';
import {Amplify} from '@aws-amplify/core';

(async () => {
  try {
    const response = await fetch('/api/config');
    const config = await response.json();
    window.appConfig = { ...config, apiServer: '/api' };
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: config.region,
        userPoolId: config.userPoolId,
        userPoolWebClientId: config.userPoolWebClientId
      },
    });
  } catch (error) {
    console.error('Failed to load config:', error);
    // Fallback
    window.appConfig = {
      region: 'us-east-1',
      userPoolId: '',
      userPoolWebClientId: '',
      apiServer: '/api',
      lookerUrlHost: '',
      lookerEmbedSecret: '',
      embedDomain: 'localhost:3000',
      lookerUrl: '',
      prodUrl: 'http://localhost:3000'
    };
  }

  const container = document.getElementById('root');
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <Router>
        <App/>
      </Router>
    </Provider>
  );
})();
// registerServiceWorker();
